<template>
    <div class="searchContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>搜索</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="searchBox">
            <div class="tableList align">
                <div :class="[active == index ? 'tableOn' : 'table']" v-for="(item,index) in searchTable" :key="index" @click="tableTap(index)">{{ item }}</div>
            </div>
            <useList :useData="searchData.gongneng" v-if="active == '0' && searchData.gongneng && searchData.gongneng.length > 0"></useList>
            <service :serviceList="searchData.fuwu" v-if="active == '1' && searchData.fuwu && searchData.fuwu.length > 0"></service>
            <goodsList :goodsList="searchData.shanpgin" v-if="active == '2' && searchData.shanpgin && searchData.shanpgin.length > 0"></goodsList>
           <div class="noDataBox column" v-if="(active == '0' && searchData.gongneng && searchData.gongneng.length == 0) || (active == '1' && searchData.fuwu && searchData.fuwu.length == 0) || (active == '2' && searchData.shanpgin && searchData.shanpgin.length == 0)">
                <el-image :src="require('@/assets/icon/noData.png')" fit="cover" class="noData"></el-image>
                <div class="noDataTips">暂无搜索结果</div>
           </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                searchTable: ['视频号功能','视频号服务','视频号选品库'],
                active: 0,
                searchData: {}
            }
        },
        watch: {
            '$route.query.key': {
                handler: function handler(e) {
                    if(this.$route.path == '/search/search'){
                        console.log(e)
                        this.getSearch(e)
                    }
                },
                immediate: true,
                deep: true
			}
        },
        mounted(){},
        methods: {
            // tab切换
            tableTap(e){
                this.active = e
            },
            // 获取首页自定义
            getSearch(e){
                this.request.get("index/search/search",{
                    params:{
                        keyword: e
                    }
                })
                .then(res=>{
                    this.searchData = res.data
                    if(res.data.gongneng.length > 0){
                        this.active = 0
                    }else if(res.data.fuwu.length > 0){
                        this.active = 1
                    }else if(res.data.shanpgin.length > 0){
                        this.active = 2
                    }
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .searchContent{
        background: #FAFBFC;
        padding-bottom: 50px;
        .searchBox{
            width: 1164px;
            padding: 0 18px 28px 18px;
            margin: 0 auto;
            background: #fff;
            border-radius: 10px;
            .tableList{
                padding: 20px 12px;
                .table{
                    font: 16px/38px "Microsoft YaHei";
                    color: #3E3E3E;
                    margin-right: 50px;
                    cursor: pointer;
                }
                .tableOn{
                    font: 18px/32px "Microsoft YaHei";
                    color: #FF6A00;
                    margin-right: 50px;
                    border-bottom: 3px solid #FF6A00;
                    padding-top: 3px;
                    cursor: pointer;
                }
            }
            .noDataBox{
                width: 1164px;
                height: 500px;
                justify-content: center;
                .noData{
                    width: 173px;
                    height: 157px;
                }
                .noDataTips{
                    font: 14px/14px "Microsoft YaHei";
                    color: #A4A4A4;
                    padding-top: 16px;
                }
            }
        }
    }
</style>